import { updateObject } from "../utility";
import {
  RESETPAGINATION,
  ALLGROUPAGENTS,
  ACTIVEPERIODS,
  SERVICECOMBO,
  PRODUCTCOMBO,
  FACTORCOMBO,
  PRICESUPERVISOR,
  PRICEPRODUCT,
  PRICESERVICE,
  PRICEFACTOR,
  PRICEPERIOD,
  GETAGAINPRICESUPERVISOR,
  GETAGAINPRICESERVICE,
  GETAGAINPRICEPRODUCT,
  GETAGAINPRICEFACTOR,
  GETAGAINPRICEPERIOD,
  ACCALLGROUP,
  ACCFINANCIAL,
  ACCHISTORYINCTIME,
  DEFAULTPANEL,
  GETAGAINDEFAULTPANEL,
  CREDITTYPE,
  CREDITMETHOD,
  MANUALCREDIT,
  DEFAULTCHARGE,
  GETAGAINDEFAULTCHARGE,
  DISCOUNTCARD,
  GETAGAINDISCOUNTCARD,
  DISCOUNTCARDSTYPE,
  DISCOUNTCARDREFRENCE,
} from "Stores/actionTypes";

const INIT_STATE = {
  allGroupAgents: null,
  accountPriceSupervisor: null,
  accountPriceService: null,
  accountPriceProduct: null,
  accountPriceFactor: null,
  accountPricePeriod: null,
  accountingFinancial: null,
  accountingDefaultPanel: null,
  accountingDefaultCharge: null,
  accountingDiscountCard: null,
  accountingIncTimeHistory: null,
  accountingManualCredit: null,
  activePeriods: null,
  serviceCombo: null,
  productCombo: null,
  factorCombo: null,
  allGroups: null,
  discountCardStype: null,
  discountCardRefrence: null,
  creditMethod: null,
  creditType: null,
  getPriceSupervisorAgain: false,
  getPriceServiceAgain: false,
  getPriceProductAgain: false,
  getPriceFactorAgain: false,
  getPricePeriodAgain: false,
  getDefaultPanelAgain: false,
  getDefaultChargeAgain: false,
  getDiscountCardAgain: false,
  pagination: { Limit: 10, Page: 1, Total: 0 },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALLGROUPAGENTS:
      return updateObject(state, {
        allGroupAgents: action.data,
        pagination: action.pagination,
      });
    case ACTIVEPERIODS:
      return updateObject(state, {
        activePeriods: action.data,
      });
    case SERVICECOMBO:
      return updateObject(state, {
        serviceCombo: action.data,
      });
    case PRODUCTCOMBO:
      return updateObject(state, {
        productCombo: action.data,
      });
    case FACTORCOMBO:
      return updateObject(state, {
        factorCombo: action.data,
      });
    case ACCALLGROUP:
      return updateObject(state, {
        allGroups: action.data,
      });
    case DISCOUNTCARDSTYPE:
      return updateObject(state, {
        discountCardStype: action.data,
      });
    case DISCOUNTCARDREFRENCE:
      return updateObject(state, {
        discountCardRefrence: action.data,
      });
    case CREDITMETHOD:
      return updateObject(state, {
        creditMethod: action.data,
      });
    case CREDITTYPE:
      return updateObject(state, {
        creditType: action.data,
      });
    case PRICESUPERVISOR:
      return updateObject(state, {
        accountPriceSupervisor: action.data,
        getPriceSupervisorAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINPRICESUPERVISOR : 
      return updateObject(state, {
        getPriceSupervisorAgain: true
      });
    case PRICESERVICE:
      return updateObject(state, {
        accountPriceService: action.data,
        getPriceServiceAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINPRICESERVICE:
      return updateObject(state, {
        getPriceServiceAgain: true
      });
    case PRICEPRODUCT:
      return updateObject(state, {
        accountPriceProduct: action.data,
        getPriceProductAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINPRICEPRODUCT:
      return updateObject(state, {
        getPriceProductAgain: true
      });
    case PRICEFACTOR:
      return updateObject(state, {
        accountPriceFactor: action.data,
        getPriceFactorAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINPRICEFACTOR:
      return updateObject(state, {
        getPriceFactorAgain: true
      });
    case PRICEPERIOD:
      return updateObject(state, {
        accountPricePeriod: action.data,
        getPricePeriodAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINPRICEPERIOD:
      return updateObject(state, {
        getPricePeriodAgain: true
      });
    case DEFAULTPANEL:
      return updateObject(state, {
        accountingDefaultPanel: action.data,
        getDefaultPanelAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINDEFAULTPANEL:
      return updateObject(state, {
        getDefaultPanelAgain: true
      });
    case DEFAULTCHARGE:
      return updateObject(state, {
        accountingDefaultCharge: action.data,
        getDefaultChargeAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINDEFAULTCHARGE:
      return updateObject(state, {
        getDefaultChargeAgain: true
      });
    case DISCOUNTCARD:
      return updateObject(state, {
        accountingDiscountCard: action.data,
        getDiscountCardAgain: false,
        pagination: action.pagination,
      });
    case GETAGAINDISCOUNTCARD:
      return updateObject(state, {
        getDiscountCardAgain: true
      });
    case ACCFINANCIAL:
      return updateObject(state, {
        accountingFinancial: action.data,
        pagination: action.pagination,
      });
    case ACCHISTORYINCTIME:
      return updateObject(state, {
        accountingIncTimeHistory: action.data,
        pagination: action.pagination,
      });
    case MANUALCREDIT:
        return updateObject(state, {
          accountingManualCredit: action.data,
          pagination: action.pagination,
        });
    case RESETPAGINATION:
      return updateObject(state, {
        pagination: { Limit: 10, Page: 1, Total: 0 },
      });
    default:
      return state;
  }
};
